
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/JakeArnold-for-LG",
      function () {
        return require("private-next-pages/JakeArnold-for-LG/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/JakeArnold-for-LG"])
      });
    }
  